import axios from "axios";
import { API_BASE_URL } from "../config/constants";


class BookingModel {
  constructor() {
    const data = JSON.parse(localStorage.getItem("bookingData")) || {};

    this._adjustDistance = data.adjustDistance || 0;
    this._cabinBag = data.cabinBag || 0;
    this._cardCharge = data.cardCharge || 0;
    this._cgst = data.cgst || 0;
    this._counter = data.counter || "";
    this._description = data.description || "";
    this._destination = data.destination || "";
    this._fareAmount = data.fareAmount || 0;
    this._highRangeCharge = data.highRangeCharge || 0;
    this._kidsCount = data.kidsCount || 0;
    this._largeBag = data.largeBag || 0;
    this._login = data.login || "";
    this._mediumBag = data.mediumBag || 0;
    this._passengerEmail = data.passengerEmail || "";
    this._passengerCount = data.passengerCount || "";
    this._passengerName = data.passengerName || "";
    this._passengerPhone = data.passengerPhone || "";
    this._peakTimeCharge = data.peakTimeCharge || 0;
    this._serviceTax = data.serviceTax || 0;
    this._sgst = data.sgst || 0;
    this._standCounter = data.standCounter || "";
    this._surcharge = data.surcharge || 0;
    this._tollCharge = data.tollCharge || 0;
    this._tollDescription = data.tollDescription || "";
    this._totalAmount = data.totalAmount || 0;
    this._tripDate = data.tripDate || "";
    this._tripDistance = data.tripDistance || 0;
    this._vehicleRate = data.vehicleRate || 0;
    this._waitMinute = data.waitMinute || 0;
    this._waitingCharge = data.waitingCharge || 0;


    this._requestReferenceNo = data.requestReferenceNo || "";
  }



  get tripDate() { return this._tripDate; }
  set tripDate(value) { this._tripDate = value; this._save(); }

  get login() { return this._login; }
  set login(value) { this._login = value; this._save(); }

  get counter() { return this._counter; }
  set counter(value) { this._counter = value; this._save(); }

  get standCounter() { return this._standCounter; }
  set standCounter(value) { this._standCounter = value; this._save(); }

  get passengerName() { return this._passengerName; }
  set passengerName(value) { this._passengerName = value; this._save(); }

  get passengerPhone() { return this._passengerPhone; }
  set passengerPhone(value) { this._passengerPhone = value; this._save(); }

  get passengerEmail() { return this._passengerEmail; }
  set passengerEmail(value) { this._passengerEmail = value; this._save(); }

  get destination() { return this._destination; }
  set destination(value) { this._destination = value; this._save(); }

  get tripDistance() { return this._tripDistance; }
  set tripDistance(value) { this._tripDistance = value; this._save(); }

  get fareAmount() { return this._fareAmount; }
  set fareAmount(value) { this._fareAmount = value; this._save(); }
  
  get surcharge() { return this._surcharge; }
  set surcharge(value) { this._surcharge = value; this._save(); }

  get cgst() { return this._cgst; }
  set cgst(value) { this._cgst = value; this._save(); }

  get sgst() { return this._sgst; }
  set sgst(value) { this._sgst = value; this._save(); }

  get tollCharge() { return this._tollCharge; }
  set tollCharge(value) { this._tollCharge = value; this._save(); }

  get serviceTax() { return this._serviceTax; }
  set serviceTax(value) { this._serviceTax = value; this._save(); }

  get totalAmount() { return this._totalAmount; }
  set totalAmount(value) { this._totalAmount = value; this._save(); }

  get waitingCharge() { return this._waitingCharge; }
  set waitingCharge(value) { this._waitingCharge = value; this._save(); }

  get highRangeCharge() { return this._highRangeCharge; }
  set highRangeCharge(value) { this._highRangeCharge = value; this._save(); }

  get vehicleRate() { return this._vehicleRate; }
  set vehicleRate(value) { this._vehicleRate = value; this._save(); }

  get adjustDistance() { return this._adjustDistance; }
  set adjustDistance(value) { this._adjustDistance = value; this._save(); }

  get additionalDistance() { return this._additionalDistance; }
  set additionalDistance(value) { this._additionalDistance = value; this._save(); }

  get waitMinute() { return this._waitMinute; }
  set waitMinute(value) { this._waitMinute = value; this._save(); }

  get tollDescription() { return this._tollDescription; }
  set tollDescription(value) { this._tollDescription = value; this._save(); }


  get cardCharge() { return this._cardCharge; }
  set cardCharge(value) { this._cardCharge = value; this._save(); }

  get peakTimeCharge() { return this._peakTimeCharge; }
  set peakTimeCharge(value) { this._peakTimeCharge = value; this._save(); }


  get description() { return this._description; }
  set description(value) { this._description = value; this._save(); }

  get passengerCount() { return this._passengerCount; }
  set passengerCount(value) { this._passengerCount = value; this._save(); }

  get kidsCount() { return this._kidsCount; }
  set kidsCount(value) { this._kidsCount = value; this._save(); }

  get largeBag() { return this._largeBag; }
  set largeBag(value) { this._largeBag = value; this._save(); }

  get mediumBag() { return this._mediumBag; }
  set mediumBag(value) { this._mediumBag = value; this._save(); }

  get cabinBag() { return this._cabinBag; }
  set cabinBag(value) { this._cabinBag = value; this._save(); }
  _save() {
    localStorage.setItem("bookingData", JSON.stringify({

      tripDate: this._tripDate,
      login: this._login,
      counter: this._counter,
      standCounter: this._standCounter,
      passengerName: this._passengerName,
      passengerPhone: this._passengerPhone,
      passengerEmail: this._passengerEmail,
      destination: this._destination,
      tripDistance: this._tripDistance,
      fareAmount: this._fareAmount,
      surcharge: this._surcharge,
      cgst: this._cgst,
      sgst: this._sgst,
      tollCharge: this._tollCharge,
      serviceTax: this._serviceTax,
      totalAmount: this._totalAmount,
      waitingCharge: this._waitingCharge,
      highRangeCharge: this._highRangeCharge,
      vehicleRate: this._vehicleRate,
      adjustDistance: this._adjustDistance,
      waitMinute: this._waitMinute,
      tollDescription: this._tollDescription,
      cardCharge: this._cardCharge,
      peakTimeCharge: this._peakTimeCharge,
      description: this._description,
      passengerCount: this._passengerCount,
      kidsCount: this._kidsCount,
      largeBag: this._largeBag,
      mediumBag: this._mediumBag,
      cabinBag: this._cabinBag
    }));
  }

  async createBooking() {
    try {
      const response = await axios.post(`${API_BASE_URL}booking-token`, {
        tripDate: this._tripDate,
        login: this._login,
        counter: this._counter,
        standCounter: this._standCounter,
        passengerName: this._passengerName,
        passengerPhone: this._passengerPhone,
        passengerEmail: this._passengerEmail,
        destination: this._destination,
        tripDistance: this._tripDistance,
        fareAmount: this._fareAmount,
        surcharge: this._surcharge,
        cgst: this._cgst,
        sgst: this._sgst,
        tollCharge: this._tollCharge,
        serviceTax: this._serviceTax,
        totalAmount: this._totalAmount,
        waitingCharge: this._waitingCharge,
        highRangeCharge: this._highRangeCharge,
        vehicleRate: this._vehicleRate,
        adjustDistance: this._adjustDistance,
        waitMinute: this._waitMinute,
        tollDescription: this._tollDescription,
        cardCharge: this._cardCharge,
        peakTimeCharge: this._peakTimeCharge,
        description: this._description,
        passengerCount: this._passengerCount,
        kidsCount: this._kidsCount,
        largeBag: this._largeBag,
        mediumBag: this._mediumBag,
        cabinBag: this._cabinBag
        
      },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error creating booking:", error);
      throw error;
    }
  }
  async allocateBooking() {
    try {
      const response = await axios.post(`${API_BASE_URL}booking-request`, {
        tripDate: this._tripDate,
        login: this._login,
        counter: this._counter,
        standCounter: this._standCounter,
        passengerName: this._passengerName,
        passengerPhone: this._passengerPhone,
        passengerEmail: this._passengerEmail,
        destination: this._destination,
        tripDistance: this._tripDistance,
        fareAmount: this._fareAmount,
        surcharge: this._surcharge,
        cgst: this._cgst,
        sgst: this._sgst,
        tollCharge: this._tollCharge,
        serviceTax: this._serviceTax,
        totalAmount: this._totalAmount,
        waitingCharge: this._waitingCharge,
        highRangeCharge: this._highRangeCharge,
        vehicleRate: this._vehicleRate,
        adjustDistance: this._adjustDistance,
        waitMinute: this._waitMinute,
        tollDescription: this._tollDescription,
        cardCharge: this._cardCharge,
        peakTimeCharge: this._peakTimeCharge,
        description: this._description,
        passengerCount: this._passengerCount,
        kidsCount: this._kidsCount,
        largeBag: this._largeBag,
        mediumBag: this._mediumBag,
        cabinBag: this._cabinBag
      });
      return response.data;
    } catch (error) {
      console.error("Error creating booking:", error);
      throw error;
    }
  }

  async updatePaidStatus(bookingId, paidStatus, no) {
    try {
      const response = await axios.put(`${API_BASE_URL}payment-status/${paidStatus}/bid/${bookingId}/no/${no}`);
      return response.data;
    } catch (error) {
      console.error("Error updating paid status:", error);
      throw error;
    }
  }

  async updateBookingStatus(bookingId, status) {
    try {
      const response = await axios.put(`${API_BASE_URL}booking-status/${status}/bid/${bookingId}`);
      return response.data;
    } catch (error) {
      console.error("Error updating booking status:", error);
      throw error;
    }
  }


  async getBookingDetails(bookingReferenceNo) {
    try {
      const response = await axios.get(`${API_BASE_URL}booking/${bookingReferenceNo}`);

      const data = response.data.data;

      this._tripDate = data.TRIP_DATE;
      this._login = data.LOGIN;
      this._counter = data.COUNTER;
      this._standCounter = data.STAND_COUNTER;
      this._passengerName = data.NAME_OF_PASSENGER;
      this._passengerPhone = data.PASSENGER_PHONE;
      this._passengerEmail = data.PASSENGER_EMAIL;
      this._destination = data.DESTINATION;
      this._tripDistance = data.TRIP_DISTANCE;
      this._fareAmount = data.FARE_AMOUNT;
      this._surcharge = data.SURCHARGE;
      this._cgst = data.CGST;
      this._sgst = data.SGST;
      this._tollCharge = data.TOLL_CHARGE;
      this._serviceTax = data.SERVICE_TAX;
      this._totalAmount = data.TOTAL_AMOUNT;
      this._waitingCharge = data.WAITING_CHARGE;
      this._highRangeCharge = data.HIGH_RANGE_CHARGE;
      this._vehicleRate = data.VEHICLE_RATE;
      this._adjustDistance = data.ADJUST_DISTANCE;
      this._waitMinute = data.WAIT_MINUTE;
      this._tollDescription = data.TOLL_DESCRIPTION;
      this._cardCharge = data.CARD_CHARGE;
      this._peakTimeCharge = data.PEAK_TIME_CHARGE;
      this._description = data.DESCRIPTION;

      this._passengerCount = data.PASSENGER_COUNT;
      this._kidsCount = data.KIDS_COUNT;
      this._largeBag = data.LARGE_BAG;
      this._mediumBag = data.MEDIUM_BAG;
      this._cabinBag = data.CABIN_BAG;

      this._save();

      return data;
    } catch (error) {
      console.error("Error fetching booking details:", error);
      throw error;
    }
  }



}

export default new BookingModel();